<template>
    <div class="home-index-page">
        <div class="web_index_main_container">
            <div class="content_outer">
                <div class="content_inner">
                    <div>
                        <div
                            class="index_left_column index_superitem_list mobile_none"
                        >
                            <gh-sidebar
                                class="index-superitem-sidebar"
                                :items="superSidebarItems"
                                :active-id="activeSuperSidebarId"
                                :icon-size="24"
                                :auto-scroll-active="false"
                                :active-scroll-behavior="
                                    ScrollBehaviorMode.Auto
                                "
                                @change-item="handleSuperSidebarChange"
                            ></gh-sidebar>
                        </div>

                        <div class="index_right_column">
                            <div class="index_banner_content">
                                <div
                                    class="home-index-top-banner"
                                    ca-ev-cg="首頁Banner"
                                    @click="openCurrentBanner"
                                >
                                    <image-swiper
                                        v-if="bannerImages.length > 0"
                                        class="index-top-banner-swiper"
                                        :class="{
                                            'is-clickable': !!currentBannerLink,
                                        }"
                                        :images="bannerImages"
                                        :is-auto="true"
                                        :delay="8000"
                                        :arrows="false"
                                        :dots="true"
                                        aspect-ratio="57 / 32"
                                        :loading="IMAGE_LOADING.EAGER"
                                        :fetch-priority="
                                            IMAGE_FETCH_PRIORITY.HIGH
                                        "
                                        lazy-tag="home-banner-desktop"
                                        @return-show="handleBannerShow"
                                    ></image-swiper>
                                    <img
                                        v-else
                                        :src="homeBannerLoadingImageUrl"
                                        loading="eager"
                                        fetchpriority="high"
                                        decoding="async"
                                        width="570"
                                        height="320"
                                        alt="banner loading"
                                    />
                                </div>
                                <div class="count_box mobile_none none">
                                    <div class="index_news_content"></div>
                                    <div class="bold comment_10">
                                        累積瀏覽人次：
                                        <span class="viewCount"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="index_quick_content">
                                <component
                                    :is="quickLink.url ? 'a' : 'button'"
                                    v-for="quickLink in quickLinkList"
                                    :id="quickLink.id || undefined"
                                    :key="quickLink.title"
                                    :href="quickLink.url || undefined"
                                    :type="quickLink.url ? undefined : 'button'"
                                    :class="quickLink.extraClass"
                                >
                                    <list-item
                                        :title="quickLink.title"
                                        :subtitle="quickLink.subtitle"
                                    >
                                        <template #icon>
                                            <span
                                                :class="[
                                                    'quick_img',
                                                    quickLink.iconClass,
                                                ]"
                                            ></span>
                                        </template>
                                    </list-item>
                                </component>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="web_index_main_container">
            <div class="content_outer">
                <div class="content_inner">
                    <div class="index_one_column">
                        <product-frame
                            title="主打商品"
                            lazy-tag="product-card-thumb"
                            :show-sidebar="false"
                            :show-more="false"
                            :products="featuredFrameProducts"
                            :empty-state="SectionEmptyState.Default"
                        ></product-frame>
                    </div>
                </div>
            </div>
        </div>

        <div class="web_index_main_container">
            <div class="content_outer">
                <div class="content_inner">
                    <div class="index_one_column">
                        <product-frame
                            title="行業類別"
                            lazy-tag="product-card-thumb"
                            more-url="/Industry/RecommendedProducts"
                            :show-sidebar="true"
                            :sidebar-items="themeSidebarItems"
                            :sidebar-active-id="currentThemeID"
                            :products="currentThemeFrameProducts"
                            :empty-state="SectionEmptyState.Default"
                            @change-sidebar="handleThemeSidebarChange"
                        ></product-frame>
                    </div>
                </div>
            </div>
        </div>

        <div class="web_index_main_container">
            <div class="content_outer">
                <div class="content_inner">
                    <div id="productSuperMenu" class="index_one_column">
                        <div class="product_super_content">
                            <ul>
                                <li
                                    v-for="sectionConfig in productSectionConfigs"
                                    :key="sectionConfig.superClassID"
                                    :class="{
                                        current_super:
                                            currentSuperClassID ===
                                            sectionConfig.superClassID,
                                    }"
                                    @click="
                                        scrollToProductSection(
                                            sectionConfig.superClassID
                                        )
                                    "
                                >
                                    <span>
                                        <template
                                            v-for="(
                                                segment, segmentIndex
                                            ) in sectionConfig.titleBarSegments"
                                        >
                                            <br
                                                v-if="segmentIndex > 0"
                                                :key="`titlebar-br-${sectionConfig.superClassID}-${segmentIndex}`"
                                            />
                                            {{ segment }}
                                        </template>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div id="productBoxs" class="product_boxs">
                        <product-frame
                            v-for="sectionConfig in productSectionConfigs"
                            :id="`SuperClassArea_${sectionConfig.superClassID}`"
                            :key="sectionConfig.superClassID"
                            :title="sectionConfig.title"
                            lazy-tag="product-card-thumb"
                            :more-url="sectionConfig.moreUrl"
                            :show-more="true"
                            :show-sidebar="
                                sectionConfig.mainClassMenu.length > 0
                            "
                            :sidebar-items="sectionConfig.mainClassMenu"
                            :sidebar-active-id="
                                sectionConfig.selectedMainClassID
                            "
                            :sidebar-context="sectionConfig.superClassID"
                            :products="sectionConfig.products"
                            :visible-rows="1"
                            :empty-state="SectionEmptyState.Default"
                            @change-sidebar="
                                handleProductSectionMainClassChange
                            "
                        ></product-frame>
                    </div>
                </div>
            </div>
        </div>

        <div class="web_index_main_container">
            <div class="content_outer">
                <div class="content_inner" style="margin-top: 1rem">
                    <home-news :initial-news-list="newsList"></home-news>
                </div>
            </div>
        </div>

        <div class="web_index_main_container">
            <div class="content_outer">
                <div class="content_inner">
                    <div class="index_one_column index_faq_content">
                        <div class="title_box">常見問題</div>
                        <div class="content_box">
                            <a
                                v-for="faqLink in faqLinkList"
                                :key="faqLink.url"
                                :href="faqLink.url"
                                class="faq_btn"
                            >
                                <list-item
                                    :title="faqLink.title"
                                    :subtitle="faqLink.subtitle"
                                >
                                    <template #icon>
                                        <div
                                            :class="[
                                                'faq_img',
                                                faqLink.iconClass,
                                            ]"
                                        ></div>
                                    </template>
                                </list-item>
                            </a>
                        </div>
                        <div class="faq_more">
                            <a href="/Home/faq" class="title_more">
                                <span>查看更多</span>
                                <div class="arrow-right"></div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <gh-modal
            v-if="popAdState"
            ref="emDialogModalRef"
            class="em-dialog-modal"
            @closed="handlePopAdClosed"
        >
            <div class="em-dialog-content">
                <video
                    v-if="popAdState.isVideo"
                    class="em-dialog-media"
                    controls
                    autoplay
                    muted
                    loop
                >
                    <source :src="popAdState.mediaUrl" type="video/mp4" />
                </video>
                <component
                    :is="popAdLinkTag"
                    v-else-if="shouldShowPopAdImage"
                    :href="popAdHref"
                    :target="popAdTarget"
                    :style="popAdLinkStyle"
                    :title="popAdState.title"
                >
                    <picture>
                        <source
                            v-if="popAdState.mediaCacheUrl"
                            :srcset="popAdState.mediaCacheUrl"
                            type="image/webp"
                        />
                        <img
                            class="em-dialog-media"
                            :src="popAdState.mediaUrl"
                            fetchpriority="auto"
                            decoding="async"
                            :alt="popAdState.title || ''"
                        />
                    </picture>
                </component>
            </div>
            <template #footer>
                <div class="em-dialog-option">
                    <input
                        id="dontshow_popad"
                        v-model="dontShowPopAd"
                        type="checkbox"
                    />
                    <label for="dontshow_popad">不要再顯示</label>
                </div>
            </template>
        </gh-modal>
    </div>
</template>

<script setup lang="ts">
    import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
    import GhModal from '@/components/base/GhModal.vue';
    import GhSidebar from '@/components/base/GhSidebar.vue';
    import ImageSwiper from '@/components/base/ImageSwiper.vue';
    import ListItem from '@/components/base/ListItem.vue';
    import ProductFrame from '@/components/products/ProductFrame.vue';
    import HomeNews from './HomeNews.vue';
    import {
        IMAGE_FETCH_PRIORITY,
        IMAGE_LOADING,
    } from '@/types/components/image-loading.types';
    import {
        ScrollBehaviorMode,
        SectionEmptyState,
        type SectionFrameSidebarChangePayload,
        type SidebarMenuPayload,
    } from '@/types/components/base-components.types';
    import type {
        HomePopAdState,
        HomeProductSuperClass,
        HomeTheme,
        ProductFrameItem,
    } from './home-index.shared';
    import {
        HOME_BANNER_LOADING_IMAGE_URL,
        buildHomeQuickLinkList,
        buildThemeSidebarItems,
        getProductsClassificationUrl,
        homeFaqLinkList,
        homeSuperClassSidebarItems,
        normalizeMainClassProductToFrameProduct,
        normalizeThemeProductToFrameProduct,
        resolveHomeIndexInitialState,
        resolveInitialMainClassIdMap,
        resolveInitialSuperSidebarId,
        resolveInitialThemeId,
    } from './home-index.shared';

    type HomeProductSectionConfig = {
        superClassID: string;
        title: string;
        titleBarSegments: string[];
        moreUrl: string;
        selectedMainClassID: string;
        mainClassMenu: Array<{
            value: string;
            label: string;
            code: string;
            mainClassID: string;
            mainClassName: string;
            productCode: string;
        }>;
        products: ProductFrameItem[];
    };

    type GhModalRef = {
        open: (options?: Record<string, unknown>) => void;
    };

    // ----- state -----
    const initialState = resolveHomeIndexInitialState();

    const activeSuperSidebarId = ref(
        resolveInitialSuperSidebarId(homeSuperClassSidebarItems)
    );
    const activeBannerIndex = ref(0);
    const currentThemeID = ref(
        resolveInitialThemeId(initialState.themeList || [])
    );
    const currentSuperClassID = ref(
        initialState.superClassList &&
            initialState.superClassList.length > 0 &&
            initialState.superClassList[0].SuperClassID
            ? String(initialState.superClassList[0].SuperClassID)
            : ''
    );
    const selectedMainClassIDMap = ref(
        resolveInitialMainClassIdMap(initialState.superClassList || [])
    );
    const dontShowPopAd = ref(false);
    const emDialogModalRef = ref<GhModalRef | null>(null);
    let productSuperMenuSyncFrameId = 0;
    const superSidebarItems = homeSuperClassSidebarItems;
    const faqLinkList = homeFaqLinkList;
    const homeBannerLoadingImageUrl = HOME_BANNER_LOADING_IMAGE_URL;

    // ----- computed -----
    const quickLinkList = computed(() => {
        return buildHomeQuickLinkList(!!initialState.isAuthenticated);
    });

    const featuredFrameProducts = computed(() => {
        return (initialState.featuredProducts || []).map((product) =>
            normalizeThemeProductToFrameProduct(product)
        );
    });

    const themeList = computed<HomeTheme[]>(() => {
        return initialState.themeList || [];
    });

    const themeSidebarItems = computed(() => {
        return buildThemeSidebarItems(themeList.value);
    });

    const currentThemeFrameProducts = computed(() => {
        const currentTheme = themeList.value.find(
            (theme) => String(theme.ThemeID || '') === currentThemeID.value
        );
        return Array.isArray(currentTheme?.ClassList)
            ? currentTheme!.ClassList!.map((product) =>
                  normalizeThemeProductToFrameProduct(product)
              )
            : [];
    });

    const bannerImages = computed(() => {
        return (initialState.bannerList || [])
            .map((item) => String(item.content || ''))
            .filter((item) => item !== '');
    });

    const currentBanner = computed(() => {
        if (!initialState.bannerList || initialState.bannerList.length === 0) {
            return null;
        }

        const safeIndex = Math.max(
            0,
            Math.min(
                activeBannerIndex.value,
                initialState.bannerList.length - 1
            )
        );
        return initialState.bannerList[safeIndex] || null;
    });

    const currentBannerLink = computed(() => {
        return currentBanner.value && currentBanner.value.link
            ? String(currentBanner.value.link).trim()
            : '';
    });

    const productSectionConfigs = computed<HomeProductSectionConfig[]>(() => {
        // 將大類標題列文字依 <br> 切成多段，供樣板逐段輸出純文字並補回換行
        const splitTitleBarSegments = (value?: string): string[] => {
            const normalized = String(value || '');
            if (normalized === '') {
                return [];
            }

            return normalized.split(/<br\s*\/?>/i);
        };

        return (initialState.superClassList || []).map(
            (superClass: HomeProductSuperClass) => {
                const superClassID = String(superClass.SuperClassID || '');
                const mainClassList = Array.isArray(
                    superClass.ProductMainClassList
                )
                    ? superClass.ProductMainClassList
                    : [];
                const fallbackMainClassID =
                    mainClassList.length > 0
                        ? String(mainClassList[0].MainClassID || '')
                        : '';
                const selectedMainClassID =
                    selectedMainClassIDMap.value[superClassID] ||
                    fallbackMainClassID;
                const selectedMainClass = mainClassList.find(
                    (mainClass) =>
                        String(mainClass.MainClassID || '') ===
                        selectedMainClassID
                );
                const productClassList = Array.isArray(
                    selectedMainClass?.ProductClassList
                )
                    ? selectedMainClass!.ProductClassList!
                    : [];

                return {
                    superClassID,
                    title: superClass.SuperClassName || '',
                    titleBarSegments: splitTitleBarSegments(
                        superClass.SuperClassNameBar ||
                            superClass.SuperClassName ||
                            ''
                    ),
                    moreUrl: getProductsClassificationUrl(
                        superClassID,
                        selectedMainClassID
                    ),
                    selectedMainClassID,
                    mainClassMenu: mainClassList.map((mainClass) => ({
                        value: String(mainClass.MainClassID || ''),
                        label: mainClass.MainClassName || '',
                        code: mainClass.ProductCode || '',
                        mainClassID: String(mainClass.MainClassID || ''),
                        mainClassName: mainClass.MainClassName || '',
                        productCode: mainClass.ProductCode || '',
                    })),
                    products: productClassList.map((productClass, index) =>
                        normalizeMainClassProductToFrameProduct(
                            superClassID,
                            selectedMainClassID,
                            productClass,
                            index
                        )
                    ),
                };
            }
        );
    });

    const newsList = computed(() => {
        return initialState.newsList || [];
    });

    const popAdState = computed<HomePopAdState | null>(() => {
        return initialState.popAd || null;
    });

    const shouldShowPopAdImage = computed(() => {
        return !!(
            popAdState.value &&
            !popAdState.value.isVideo &&
            popAdState.value.shouldShow &&
            popAdState.value.mediaUrl
        );
    });

    const popAdHasLink = computed(() => {
        return !!(popAdState.value && popAdState.value.link);
    });

    // 無連結的彈窗廣告不使用 <a>，改用 <div> 包住圖片，避免產生無法檢索的空連結
    const popAdLinkTag = computed(() => {
        return popAdHasLink.value ? 'a' : 'div';
    });

    const popAdHref = computed(() => {
        return popAdHasLink.value ? String(popAdState.value!.link) : undefined;
    });

    const popAdTarget = computed(() => {
        if (!popAdHasLink.value) {
            return undefined;
        }

        return Number(popAdState.value!.act || 0) === 1 ? '_self' : '_blank';
    });

    const popAdLinkStyle = computed(() => {
        if (popAdHasLink.value) {
            return {};
        }

        return {
            cursor: 'default',
        };
    });

    // ----- methods -----
    const handleSuperSidebarChange = (payload: SidebarMenuPayload) => {
        if (!payload || !payload.item || !payload.item.url) {
            return;
        }

        activeSuperSidebarId.value = String(payload.itemId || '');
        window.location.href = payload.item.url;
    };

    const handleBannerShow = (index: number) => {
        if (!Number.isFinite(index)) {
            return;
        }

        activeBannerIndex.value = Number(index);
    };

    const openCurrentBanner = () => {
        if (!currentBannerLink.value) {
            return;
        }

        const openTarget =
            currentBanner.value && Number(currentBanner.value.act || 0) === 1
                ? '_self'
                : '_blank';
        window.open(currentBannerLink.value, openTarget);
    };

    const handleThemeSidebarChange = (
        payload: SectionFrameSidebarChangePayload
    ) => {
        if (!payload || !payload.itemId) {
            return;
        }

        currentThemeID.value = String(payload.itemId);
    };

    const handleProductSectionMainClassChange = (
        payload: SectionFrameSidebarChangePayload
    ) => {
        if (!payload || !payload.itemId || !payload.sidebarContext) {
            return;
        }

        selectedMainClassIDMap.value = {
            ...selectedMainClassIDMap.value,
            [String(payload.sidebarContext)]: String(payload.itemId),
        };
    };

    const scrollToProductSection = (superClassID: string) => {
        currentSuperClassID.value = superClassID;
        const targetElement = document.getElementById(
            `SuperClassArea_${superClassID}`
        );
        if (!(targetElement instanceof HTMLElement)) {
            return;
        }

        const scrollTop =
            window.scrollY ||
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            0;
        const targetOffsetTop =
            targetElement.getBoundingClientRect().top + scrollTop;
        window.scrollTo({
            top: Math.max(targetOffsetTop - 112, 0),
            behavior: 'smooth',
        });
    };

    // 商品大類錨點的 fixed 與 active 狀態
    const syncProductSuperMenuState = () => {
        const productSuperMenuContent = document.querySelector(
            '#productSuperMenu .product_super_content'
        );
        const productBoxElement = document.getElementById('productBoxs');
        if (!(productSuperMenuContent instanceof HTMLElement)) {
            return;
        }

        if (!(productBoxElement instanceof HTMLElement)) {
            productSuperMenuContent.classList.remove('product_super_fixed');
            return;
        }

        const scrollTop =
            window.scrollY ||
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            0;
        const productBoxOffsetTop =
            productBoxElement.getBoundingClientRect().top + scrollTop;
        productSuperMenuContent.classList.toggle(
            'product_super_fixed',
            scrollTop >= productBoxOffsetTop - 120
        );

        const superClassAreas = Array.from(
            document.querySelectorAll('#productBoxs .section-frame')
        );
        // 區塊命中範圍沿用舊首頁 300px 提前量，讓目前大類高亮能在視覺上更早同步
        const matchedSection = superClassAreas.find((area) => {
            if (!(area instanceof HTMLElement)) {
                return false;
            }

            const areaTop = area.getBoundingClientRect().top + scrollTop - 300;
            const areaHeight = area.offsetHeight;
            return scrollTop >= areaTop && scrollTop < areaTop + areaHeight;
        });
        if (!(matchedSection instanceof HTMLElement)) {
            return;
        }

        const matchedSuperClassID = matchedSection.id.replace(
            'SuperClassArea_',
            ''
        );
        if (
            matchedSuperClassID &&
            currentSuperClassID.value !== matchedSuperClassID
        ) {
            currentSuperClassID.value = matchedSuperClassID;
        }
    };

    // scroll/resize 事件集中到同一個 frame 量測，避免連續事件反覆讀取 DOM
    const requestProductSuperMenuSync = () => {
        if (productSuperMenuSyncFrameId !== 0) {
            return;
        }

        productSuperMenuSyncFrameId = window.requestAnimationFrame(() => {
            productSuperMenuSyncFrameId = 0;
            syncProductSuperMenuState();
        });
    };

    const openPopAdDialog = () => {
        if (
            window.__GH_SSR_MODE__ ||
            !popAdState.value ||
            !popAdState.value.shouldShow ||
            !emDialogModalRef.value
        ) {
            return;
        }

        emDialogModalRef.value.open({
            showReject: false,
            closeOnOverlay: true,
            closeOnEsc: true,
        });
    };

    const handlePopAdClosed = () => {
        if (!popAdState.value || !popAdState.value.id || !dontShowPopAd.value) {
            return;
        }

        document.cookie = `popad=${popAdState.value.id}; path=/; max-age=${60 * 60 * 24 * 365}`;
    };

    // ----- lifecycle -----
    onMounted(() => {
        openPopAdDialog();
        nextTick(() => {
            // 等商品區塊完成渲染後再做第一次量測，避免 offsetTop 與 section-frame 清單不完整
            syncProductSuperMenuState();
            window.addEventListener('scroll', requestProductSuperMenuSync, {
                passive: true,
            });
            window.addEventListener('resize', requestProductSuperMenuSync);
        });
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', requestProductSuperMenuSync);
        window.removeEventListener('resize', requestProductSuperMenuSync);
        if (productSuperMenuSyncFrameId !== 0) {
            window.cancelAnimationFrame(productSuperMenuSyncFrameId);
            productSuperMenuSyncFrameId = 0;
        }
    });
</script>
